/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamActivityEmployee } from './TeamActivityEmployee';
import {
    TeamActivityEmployeeFromJSON,
    TeamActivityEmployeeFromJSONTyped,
    TeamActivityEmployeeToJSON,
    TeamActivityEmployeeToJSONTyped,
} from './TeamActivityEmployee';

/**
 * 
 * @export
 * @interface TeamActivityToday
 */
export interface TeamActivityToday {
    /**
     * 
     * @type {Date}
     * @memberof TeamActivityToday
     */
    date: Date;
    /**
     * 
     * @type {Array<TeamActivityEmployee>}
     * @memberof TeamActivityToday
     */
    employees: Array<TeamActivityEmployee>;
}

/**
 * Check if a given object implements the TeamActivityToday interface.
 */
export function instanceOfTeamActivityToday(value: object): value is TeamActivityToday {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('employees' in value) || value['employees'] === undefined) return false;
    return true;
}

export function TeamActivityTodayFromJSON(json: any): TeamActivityToday {
    return TeamActivityTodayFromJSONTyped(json, false);
}

export function TeamActivityTodayFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamActivityToday {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'employees': ((json['employees'] as Array<any>).map(TeamActivityEmployeeFromJSON)),
    };
}

export function TeamActivityTodayToJSON(json: any): TeamActivityToday {
    return TeamActivityTodayToJSONTyped(json, false);
}

export function TeamActivityTodayToJSONTyped(value?: TeamActivityToday | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'].toISOString().substring(0,10),
        'employees': ((value['employees'] as Array<any>).map(TeamActivityEmployeeToJSON)),
    };
}

